var _circle, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBasketorderLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 12,
    fill: "#064AD3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 17.25C15.1082 17.25 15.5 16.8582 15.5 16.375C15.5 15.8918 15.1082 15.5 14.625 15.5C14.1418 15.5 13.75 15.8918 13.75 16.375C13.75 16.8582 14.1418 17.25 14.625 17.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 17.25C11.1082 17.25 11.5 16.8582 11.5 16.375C11.5 15.8918 11.1082 15.5 10.625 15.5C10.1418 15.5 9.75 15.8918 9.75 16.375C9.75 16.8582 10.1418 17.25 10.625 17.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92 7.97L8.82 9.195C8.8 9.43 8.985 9.625 9.22 9.625H16.875C17.085 9.625 17.26 9.465 17.275 9.255C17.34 8.37 16.665 7.65 15.78 7.65H9.635C9.585 7.43 9.485 7.22 9.33 7.045C9.08 6.78 8.73 6.625 8.37 6.625H7.5C7.295 6.625 7.125 6.795 7.125 7C7.125 7.205 7.295 7.375 7.5 7.375H8.37C8.525 7.375 8.67 7.44 8.775 7.55C8.88 7.665 8.93 7.815 8.92 7.97Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.755 10.375H9.085C8.875 10.375 8.705 10.535 8.685 10.74L8.505 12.915C8.435 13.77 9.105 14.5 9.96 14.5H15.52C16.27 14.5 16.93 13.885 16.985 13.135L17.15 10.8C17.17 10.57 16.99 10.375 16.755 10.375Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketorderLogo);
export default __webpack_public_path__ + "static/media/BasketorderLogo.ce7f5aec9c248a45683281cbcf725d4f.svg";
export { ForwardRef as ReactComponent };